import { render, staticRenderFns } from "./PublisherPostbacks.vue?vue&type=template&id=acefb670&lang=pug&"
import script from "./PublisherPostbacks.vue?vue&type=script&lang=js&"
export * from "./PublisherPostbacks.vue?vue&type=script&lang=js&"
import style0 from "./PublisherPostbacks.vue?vue&type=style&index=0&id=acefb670&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports